export const INDIVIDUAL_TAX_CLASSIFICATION_ID = 1;
